import { REQUEST_STATUSES } from "../../constants";

export const isNetworkPending = (status: REQUEST_STATUSES): boolean =>
  status === REQUEST_STATUSES.PENDING;

export const isNetworkLoading = (status: REQUEST_STATUSES): boolean =>
  status === REQUEST_STATUSES.LOADING;

export const isNetworkSuccess = (status: REQUEST_STATUSES): boolean =>
  status === REQUEST_STATUSES.SUCCESS;

export const isNetworkError = (status: REQUEST_STATUSES): boolean =>
  status === REQUEST_STATUSES.ERROR;
